import React from 'react';
import { useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { pcPageConfig } from './techlandPageConfig';
// import { dl2PcPageConfig } from './dl2PcPageConfig';

import './index.scss'; 

const reqParams = '/monetization/salesOverview';
const SalesOverview = () => {
  const dataFrame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile'
  });
  const pageMap: any = {
    pc: pcPageConfig,
  }
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </>
  );
};

export default SalesOverview;